import { ErrorScreenWrapper } from '../error';

const AuthErrorBoundary = () => (
  <ErrorScreenWrapper
    systemErrorProps={{
      isError: true,
      systemErrorScreenProps: {
        errorMsg: 'Authentication failed due to a system issue.',
      },
    }}
  >
    {null}
  </ErrorScreenWrapper>
);

export default AuthErrorBoundary;
